import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { startBugsnag } from '../../utils/bugsnagUtils';
import { ErrorFallbackComponent } from './errorFallbackComponent';
const BugsnagErrorBoundary = startBugsnag();
export const BugsnagErrorBoundaryContainer = ({ children }) => {
    if (BugsnagErrorBoundary) {
        return _jsx(BugsnagErrorBoundary, { FallbackComponent: ErrorFallbackComponent, children: children });
    }
    else {
        return _jsx(_Fragment, { children: children });
    }
};
